module.exports = __webpack_public_path__ + "static/media/20ECE5.ff29f1a8.jpg";